import { Component, input } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-identicon',
  imports: [
    TooltipModule,
  ],
  templateUrl: './identicon.component.html',
  styleUrl: './identicon.component.scss'
})
export class IdenticonComponent {
  seed = input<string>('');
  tooltip = input<string>('');

}
